import {
  ConfigActionTypes,
  ConfigActions
} from './config.actions';
import { ConfigState } from '@digitaix/types';

export const configInitialState: ConfigState = {
  version: null,
  sha: null,
  firebase:       null,
  featureFlags:   null,
  environment:    null,
  gitlab:         null,
  api:            null,
  authentication: null,
  authorisation: null,
  stackdriver: null,
  appName: null,
  components: null,
};

export function configReducer(
  state = configInitialState,
  action: ConfigActions,
): ConfigState {
  switch (action.type) {
    case ConfigActionTypes.SetConfig:
      return action.config;

    case ConfigActionTypes.SetEnvironment:
      return { ...state, environment: { ...state.environment, ...action.environment } };

    default:
      return state;
  }
}
